import { HttpResponse } from 'msw';

type LegacyBody = { command?: string; access?: string };

export function handleMqttLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  switch (command) {
    case 'get mqtt':
      return HttpResponse.json(
        {
          enabled: false,
          tls: false,
          verify: false,
          qos: 0,
          port: 1883,
          server: '',
          name: 'roqstar',
          update_enabled: false,
          update_topic: '',
          s: 'disabled',
          username: '',
          password: '',
          ca_cert: '',
          pingreq_interval: 60,
        },
        { status: 200 },
      );
    case 'set mqtt':
      return HttpResponse.json({ ok: true }, { status: 200 });
    default:
      return HttpResponse.json(
        { error: 'not implemented', msg: `Mock missing for mqtt:${command}` },
        { status: 400 },
      );
  }
}

export function handleMulticastLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  if (command === 'igmp snooping') {
    if (access === 'set') {
      return HttpResponse.json({ ok: true }, { status: 200 });
    }
    return HttpResponse.json({ snooping: false }, { status: 200 });
  }

  return HttpResponse.json(
    { error: 'not implemented', msg: `Mock missing for multicast:${command}` },
    { status: 400 },
  );
}

export function handleStaticMcLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  switch (command) {
    case 'get entries':
      return HttpResponse.json(
        [
          {
            mac: '01:00:5E:01:01:01',
            vid: 0,
            mgmtPort: true,
            ports: ['P1', 'P2'],
            description: 'Default multicast',
          },
        ],
        { status: 200 },
      );
    case 'add entry':
    case 'remove entry':
      return HttpResponse.json({ ok: true }, { status: 200 });
    default:
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: `Mock missing for staticmc:${command}`,
        },
        { status: 400 },
      );
  }
}
